export const SESSION_PREVIEW_MAX_LENGTH = 50;

export function truncateSessionPreview(text, limit = SESSION_PREVIEW_MAX_LENGTH) {
    const value = typeof text === 'string' ? text : '';
    const characters = Array.from(value);

    if (characters.length <= limit) {
        return value;
    }

    if (limit <= 1) {
        return limit === 1 ? '…' : '';
    }

    return `${characters.slice(0, limit - 1).join('')}…`;
}
